import axiosInstance from '../lib/axios';
import type { AuditParams } from '../types/audit.types';

export const auditService = {
  getAll: (params: AuditParams = {}) =>
    axiosInstance.get('/audit', { params }),

  getByCase: (caseId: number) =>
    axiosInstance.get(`/audit/case/${caseId}`),

  getByDocument: (documentId: number) =>
    axiosInstance.get(`/audit/doc/${documentId}`),
};

export default auditService;